import React, { useEffect, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Icon, Loader } from 'semantic-ui-react'
import { FarmersService } from '~/api/services/farmers'
import { FormFields } from '~/components/FormFields'
import notify from '~/components/Notify'

const FirstRow: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { control, setValue, formState: { dirtyFields } } = useFormContext()

  const [loadingSupplierCheckNo, setLoadingSupplierCheckNo] = useState(false)
  const [correctSupplierNo, setCorrectSupplierNo] = useState(true)

  const uniqueValidationMessage = t('Please enter unique supplier number')
  const watchSupplierNo = useWatch({ control, name: 'supplierNo' })
  const watchFarmerType = useWatch({ control, name: 'farmerType' })

  useEffect(() => {
    if (watchFarmerType && watchFarmerType === 'main') {
      setValue('parentId', null)
    }
  }, [watchFarmerType])

  async function checkSupplierNo(value) {
    setValue('supplierNo', value)
    setLoadingSupplierCheckNo(true)
    try {
      const payload = id ? { supplierNo: value, id } : { supplierNo: value }
      const response = await FarmersService.checkSupplierNo({ ...payload })
      setCorrectSupplierNo(Boolean(response.data))
    } catch (error) {
      if (error.response.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
    setLoadingSupplierCheckNo(false)
  }

  return <>
    <FormFields.Input
      control={control}
      name={'supplierNo'}
      placeholder={t('Suplier no.')}
      onChange={(e, data) => checkSupplierNo(data.value)}
      rules={{
        required: true,
        validate: () => !watchSupplierNo || watchSupplierNo === '' ? true : correctSupplierNo || uniqueValidationMessage
      }}
      label={<label style={{ display: 'flex', position: 'relative' }}>
        <div>{t('Suplier no.')}<span style={{ color: 'red' }}>*</span></div>
        {loadingSupplierCheckNo && <div className='loaderWrapper'>
          <Loader size='small' active={loadingSupplierCheckNo} />
        </div>}
        {!loadingSupplierCheckNo && watchSupplierNo !== '' && dirtyFields?.supplierNo && <Icon
          style={{ marginLeft: 10 }}
          name={correctSupplierNo ? 'checkmark' : 'close'}
          color={correctSupplierNo ? 'green' : 'red'}
        />}
      </label>}
    />
    <FormFields.Input
      control={control}
      name={'companyName'}
      rules={{
        required: {
          value: true,
          message: t('Plese enter company name')
        }
      }}
      placeholder={t('Company name')}
      label={t('Company name')}
    />

    <FormFields.Input
      control={control}
      allowDecimals={false}
      name={'vvvoNumber'}
      rules={{
        validate: (value) => {
          if (value && value.toString().length !== 12) {
            return `Sie haben ${value.toString().length} Zahlen eingegeben, obwohl 12 erforderlich sind.`
          }
          return true
        }
      }}
      placeholder={t('VVVO-Nr.')}
      label={<label>{t('VVVO-Nr.')}</label>}
    />

  </>
}
export default FirstRow